var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import IconUI from "@irati/ui/src/Icon";
import ButtonRouterLinkUI from "../ButtonRouterLink";
export var ButtonRouterLink = styled(ButtonRouterLinkUI)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  .button-router-link-child-wrapper {\n    display: inline-flex;\n    align-items: center;\n  }\n"], ["\n  .button-router-link-child-wrapper {\n    display: inline-flex;\n    align-items: center;\n  }\n"])));
export var Icon = styled(IconUI)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ",
    "\n"])), function (_a) {
    var hasChildren = _a.hasChildren;
    return hasChildren && "\n    margin-right: 8px;\n  ";
});
var templateObject_1, templateObject_2;
